export default {
  EMAIL_MAX_LENGTH: 254,
  NAME_MAX_LENGTH: 64,
};
